///<amd-module name="Core/Medius.Core.Web/Scripts/Medius/apps/task/validationModal"/>
import * as React from "react";
import { ModalDialog, IconStatusWarningFill, Text, Button, FlexLayout, FlexSpacer } from '@medius/ui-controls';
import { translate } from "Core/Medius.Core.Web/Scripts/lib/globalization";

interface ValidationModalProps {
    isShown: boolean
    title: string
    heading: string
    content: string
    onClose: () => void
}

export const ValidationModal = ({ isShown, title, heading, content, onClose }: ValidationModalProps) => { 

    const onRequestClose = () => {
        onClose();
    };

    return (<>
        <ModalDialog
            data-testid="validation-popup"
            showHeader             
            title={ title }
            isOpen={ isShown }
            width="small"
            onRequestClose={ onRequestClose }
            renderContent={() =>{
                return <>
                    <FlexLayout
                        spacerMode="on"
                        spacerSize="vsmall"
                        direction="column"
                        horizontalAlignment="center">
                            <Text 
                                alignment="center"
                                variant="body"
                                spacerMode="on">
                                    <IconStatusWarningFill
                                        color="warning"
                                        size="vlarge"/>
                            </Text>
                            <Text 
                                alignment="center"
                                variant="heading2">
                                { heading }
                            </Text>
                            <Text 
                                alignment="center"
                                variant="body">
                                { content }
                            </Text>
                            <FlexSpacer />
                    </FlexLayout>
                </>;
            }}
            showActionsDivider={ true }
            renderActions={() => {
                return <>
                    <Button label={ translate("#Core/close") } onClick={ onRequestClose } />
                </>;
            }}
        />
    </>);
};
